<template>
    <div class="video-library">
        <!-- 筛选按钮区域 -->
        <div class="status-filter-btns">
            <button v-for="item in statusOptions" :key="item.value"
                :class="['status-btn', { selected: statusFilter === item.value }]" @click="selectStatus(item.value)">
                {{ item.label }}
            </button>
        </div>

        <!-- 视频列表 -->
        <ul class="video-list" v-infinite-scroll="loadMore" :infinite-scroll-disabled="isLoading || isNoMore"
            :infinite-scroll-distance="50">
            <li :class="['video-item', { 'is-selected': item.isClicked }]" v-for="(item, i) in videoList" :key="i"
                @click="toggleSelect(item)" @mouseenter="item.isHovered = true" @mouseleave="item.isHovered = false">
                <div class="video-container" style="width: 110px;height: 70px;">
                    <videoPreview :cover-src="item.url" :video-id="Number(item.idVideo)" :alt="item.originalName || '视频'"
                        :video-qualities="item.videoQualities" :video-list="videoList" :current-video-index="i"
                        @click.stop />

                    <!-- 图标容器 -->
                    <div class="media-icons-container">
                        <!-- 标签图标 -->
                        <el-tooltip placement="top" effect="light" :content="getTagDescription(item)"
                            v-if="getIsShowTag(item)">
                            <div class="media-tag video-tag">
                                <img :src="getTagIcon(item)" class="tag-icon" />
                            </div>
                        </el-tooltip>
                        <!-- 是否发送过 -->
                        <el-tooltip placement="top" effect="light" :content="'发送过'" v-if="item.casualStatus == 'sent'">
                            <div class="media-tagSec">
                                <i class="el-icon-s-promotion" style="color: #fff;font-size: 18px;"></i>
                            </div>
                        </el-tooltip>
                        <!-- 是否查看过 -->
                        <el-tooltip placement="top" effect="light" :content="'查看过'"
                            v-if="item.casualStatus == 'accessed'">
                            <div class="media-tagSec" style="background: rgba(255, 255, 255, 0.7);">
                                <img src="@/assets/see.png" style="width: 14px;">
                            </div>
                        </el-tooltip>
                        <!-- 重新审核按钮 -->
                        <el-tooltip placement="top" effect="light" :content="'重新审核'"
                            v-if="shouldShowReReview(item) && item.isHovered">
                            <div class="media-tagSec video-tag" @click="reReview(item)">
                                <i class="el-icon-refresh-right" style="color: #fff;font-size: 18px;"></i>
                            </div>
                        </el-tooltip>
                    </div>
                </div>

                <!-- 选中状态指示 -->
                <div class="selection-indicator" v-if="item.isClicked">
                    <i class="el-icon-success" style="color: #5FAAFF;"></i>
                </div>
            </li>

            <!-- 加载状态 -->
            <li v-if="isLoading" class="loading-item">
                <img class="loading-icon" src="@/assets/loading.gif" alt="">
            </li>

            <!-- 无更多数据 -->
            <li v-if="isNoMore && !isLoading" class="no-more-item">
                没有更多了
            </li>
        </ul>
    </div>
</template>

<script>
import { getGalleryVideos, sendForModeration } from '@/api/talkytimes/message'
import videoPreview from '@/components/videoPreview.vue'
import { deleteVideo } from '@/api/talkytimes/attachment'

export default {
    name: 'ManagementVideoLibrary',
    components: { videoPreview },
    props: {
        chatUserInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            videoList: [],
            statusFilter: 'all',
            statusOptions: [
                { label: 'All', value: 'all' },
                { label: 'Approved', value: 'approved' },
                { label: 'Special', value: 'special' },
                { label: 'Special +', value: 'special_plus' },
                { label: 'On moderation', value: 'on_moderation' },
                { label: 'Declined', value: 'declined' },
            ],
            limit: 50,
            cursor: '',
            isLoading: false,
            isNoMore: false,
            hasError: false
        }
    },
    watch: {
        statusFilter: {
            handler() {
                this.refresh()
            }
        },
        chatUserInfo: {
            handler(newVal, oldVal) {
                if (newVal && oldVal && newVal.userId !== oldVal.userId) {
                    this.refresh()
                }
            },
            deep: true
        }
    },
    mounted() {
        this.loadVideos()
    },
    methods: {
        async loadVideos(isLoadMore = false) {
            if (this.isLoading) return
            if (this.hasError && !isLoadMore) return

            this.isLoading = true
            this.hasError = false

            const idUser = this.chatUserInfo.userId || this.chatUserInfo.idInterlocutor || this.chatUserInfo.id_user || this.chatUserInfo.id

            if (!idUser) {
                console.error('无法获取有效的用户ID')
                this.isLoading = false
                this.hasError = true
                return
            }

            const params = {
                cursor: isLoadMore ? String(this.cursor) : "",
                limit: this.limit,
                statuses: [],
                tags: [],
                excludeTags: [],
                idUser: idUser
            }

            // 根据筛选条件设置参数
            if (this.statusFilter === 'all') {
                params.statuses = []
                params.tags = []
            } else if (this.statusFilter === 'approved') {
                params.statuses = ['approved']
                params.tags = []
            } else if (this.statusFilter === 'special') {
                params.statuses = []
                params.tags = ['erotic']
            } else if (this.statusFilter === 'special_plus') {
                params.statuses = []
                params.tags = ['erotic_plus']
            } else if (this.statusFilter === 'on_moderation') {
                params.statuses = ['on_moderation']
                params.tags = []
            } else if (this.statusFilter === 'declined') {
                params.statuses = ['declined']
                params.tags = []
            }

            const res = await getGalleryVideos(params)

            const videoArr = Array.isArray(res.videos) ? res.videos : []
            const newVideos = videoArr.map(item => ({
                ...item,
                url: item.urls?.urlThumbnail || item.url,
                urlHd: item.urls?.urlMp4Hd || item.urlHd,
                urlSd: item.urls?.urlMp4Sd || item.urlSd,
                videoQualities: [
                    {
                        label: '高清',
                        src: item.urls?.urlMp4Hd || item.urlHd
                    },
                    {
                        label: '标清',
                        src: item.urls?.urlMp4Sd || item.urlSd
                    }
                ],
                originalName: item.filename || '视频',
                fileCateType: 2,
                isClicked: false,
                isHovered: false,
                tags: item.tags || [],
                status: typeof item.status === 'string' ? { code: item.status } : item.status,
                casualStatus: item.casualStatus
            }))

            if (isLoadMore) {
                this.videoList = this.videoList.concat(newVideos)
            } else {
                this.videoList = newVideos
            }

            this.cursor = res.cursor || ''
            this.isNoMore = newVideos.length < this.limit

            this.isLoading = false
        },

        loadMore() {
            if (!this.isLoading && !this.isNoMore && !this.hasError) {
                this.loadVideos(true)
            }
        },

        refresh() {
            this.cursor = ''
            this.isNoMore = false
            this.hasError = false
            this.videoList = []
            this.loadVideos()
        },

        toggleSelect(item) {
            if (!this.canSelect(item)) return

            this.$set(item, 'isClicked', !item.isClicked)

            if (item.isClicked) {
                this.$emit('item-selected', item)
            } else {
                this.$emit('item-deselected', item)
            }
        },

        canSelect(item) {
            return true // 管理模式下都可以选择
        },

        selectStatus(value) {
            this.statusFilter = value
        },

        getIsShowTag(item) {
            if (!item) return false
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '')
            if (statusValue && statusValue.includes('approved')) {
                return item.tags && Array.isArray(item.tags) && item.tags.length > 0
            }
            return false
        },

        getTagIcon(item) {
            if (!item) return ''
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '')
            if (statusValue && statusValue.includes('approved')) {
                if (item.tags && Array.isArray(item.tags) && item.tags.length > 0) {
                    const tagCode = typeof item.tags[0] === 'string' ? item.tags[0] : (item.tags[0]?.code || '')
                    switch (tagCode) {
                        case 'special_plus':
                        case 'erotic_plus':
                            return require('@/assets/svg/special+.svg')
                        case 'pre_special':
                            return require('@/assets/svg/special-.svg')
                        case 'special':
                        case 'erotic':
                            return require('@/assets/svg/special.svg')
                        default:
                            return ''
                    }
                }
            } else if (statusValue && statusValue.includes('declined')) {
                return require('@/assets/svg/negative.svg')
            } else if (statusValue === 'on_moderation') {
                return require('@/assets/svg/clock.svg')
            }
            return ''
        },

        getTagDescription(item) {
            if (!item) return ''
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '')
            if (statusValue && statusValue.includes('approved')) {
                if (item.tags && Array.isArray(item.tags) && item.tags.length > 0) {
                    const tagCode = typeof item.tags[0] === 'string' ? item.tags[0] : (item.tags[0]?.code || '')
                    switch (tagCode) {
                        case 'special_plus':
                        case 'erotic_plus':
                            return '特殊+内容'
                        case 'pre_special':
                            return 'AI预设'
                        case 'special':
                        case 'erotic':
                            return '特殊内容'
                        default:
                            return ''
                    }
                }
            } else if (statusValue && statusValue.includes('declined')) {
                return '审核不通过'
            } else if (statusValue === 'on_moderation') {
                return '审核中'
            }
            return ''
        },

        shouldShowReReview(item) {
            if (!item) return false
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '')
            if (!statusValue) return false
            if (statusValue.includes('declined')) return true
            if (statusValue === 'on_moderation') return true
            return false
        },

        async reReview(item) {
            await sendForModeration({ idVideo: item.idVideo })
            this.$message.success('重新提审成功')
            this.refresh()
        },

        async deleteItems(items) {
            if (!items || items.length === 0) return

            const itemIds = items.map(item => item.idVideo || item.id)
            await deleteVideo({ idsVideos: itemIds })

            this.videoList = this.videoList.filter(video => {
                const videoId = video.idVideo || video.id
                return !itemIds.includes(videoId)
            })

            this.$message.success(`成功删除 ${items.length} 个视频`)
        }
    }
}
</script>

<style lang="scss" scoped>
.video-library {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.status-filter-btns {
    display: flex;
    gap: 16px;
    margin: 16px 0;
    padding: 0 8px;

    .status-btn {
        padding: 4px 16px;
        border: none;
        border-radius: 16px;
        background: #f7f9fa;
        color: #333;
        font-size: 15px;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s, color 0.2s;

        &.selected {
            background: #eef2ff;
            color: #2346d4;
        }
    }
}

.video-list {
    flex: 1;
    height: 100%;
    width: 100%;
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    overflow-y: auto;

    .video-item {
        position: relative;
        display: inline-block;
        margin: 3px;
        padding: 10px;
        vertical-align: top;
        box-sizing: border-box;
        text-align: center;
        border: 1px solid transparent;
        transition: all 0.2s;
        cursor: pointer;

        &.is-selected {
            border: 1px solid #2499FF;
            border-radius: 8px;
        }

        .video-container {
            width: 110px;
            height: 110px;
            position: relative;
            display: inline-block;

            ::v-deep .videoPreview {
                width: 110px;
                height: 110px;
                display: block;
            }
        }

        .media-icons-container {
            position: absolute;
            bottom: 0;
            left: 8px;
            display: flex;
            align-items: center;
            gap: 4px;
            z-index: 10;
        }

        .media-tag,
        .media-tagSec {
            position: relative;
            background: rgba(20, 20, 20, 0.4);
            color: white;
            width: 20px;
            height: 20px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .tag-icon {
                width: 18px;
                height: 18px;
            }
        }

        .selection-indicator {
            position: absolute;
            right: 0;
            top: 2px;
        }
    }

    .loading-item,
    .no-more-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        width: 100%;
        color: #999;
        font-size: 14px;

        .loading-icon {
            width: 30px;
            height: 30px;
            animation: rotate360 1s linear infinite;
        }
    }
}

@keyframes rotate360 {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
